import { useEffect, useState } from 'react';

function usePersistedState(key: string, defaultValue: any) {
  const [state, setState] = useState(() => {
    try {
      const storedValue = window.sessionStorage.getItem(key);
      // Retourne la valeur stockée ou la valeur par défaut
      return storedValue ? JSON.parse(storedValue) : defaultValue;
    } catch (error) {
      console.error('Erreur lors de la lecture de sessionStorage :', error);
      return defaultValue;
    }
  });

  return [state, setState];
}

export default usePersistedState;
